import { DefaultTheme } from "styled-components";
import { colors } from "./colors";
import settings from "../settings/settings";

export type Themes = {
  light: DefaultTheme;
  dark: DefaultTheme;
};

export type Theme = keyof Themes;

export const themes: Themes = {
  light: colors,
  dark: {
    primary: settings?.colors?.dark?.primary ?? "#478DF5",
    secondary: "#1F1F1F",
    tertiary: "#A3A3A3",
    forth: "#D6D6D6",
    lightForth: "#DEDEE2",
    white: "#CCCCCC",
    black: "#000000",
    text: "#CCCCCC",
    op21: "#252525",
    optBorderInput: "#66666636",
    primaryLow: "#478DF5",
    transparent: "transparent",
    background: "#161616",
    attNote: "#252525",
    border: "#252525",
    primaryBorder: "#42484b",
    success: "#449980",
    showInfoFile: "#272727",
    error: "#EE384E",
    iconColor: "#868686",
    textNotActive: "#FFFFFF73",
    subBgColors: "#272727",
    inputBg: "#1F1F1F",
    medService: "#068D93",
    aiService: "#57467C",
    lifeStyleService: "#C11446",
    legalService: "#212144",
    headerInChat: "rgba(39,39,39,0.80)",
    chatBox: "#1F1F1F",
    primaryLight: "#D8E7FD73",
    lightGreen: "#26CB63",
    red: "#E02424",
    lightRed: "#FFF2F2",
    bgDynamic: "#161616",
    legalServiceColor: "#212144",
    titleColor: "#72777B",
    sendButton: "#272727FE",
    incognito: "#101010",
    disabledIcon: "#3D3D3D",
    message: "#2C2C2C",
    historyButton: "#1F1F1F",
    darkLiver: "#4F4E52",
    askQuestionButton: "#272727",
    header: "#272727",
    optTitleColor: "#72777B",
    historyHead: "#272727",
    tokenIcon: "#FF980F",
    brightGreen: "#D6FEEB",
    textGreen: "#5DC486",
    brightRed: "#F7CECE",
    textRed: "#C45D5E",
    bluredBackground: "rgba(0,0,0,0.2)",
    tickIcon: "#44b449",
  },
};
